import React, {
  useCallback, useEffect, useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { endOfWeek, format, startOfWeek } from 'date-fns';
import { useParams } from 'react-router-dom';

import MaynLayout from '../Core/MainLayout';
import styles from './Events.module.scss';
import DRP from '../Core/DRP/DRP';
import SearchIcon from '../Icons/SearchIcon';
import Input from '../Core/Input/Input';
// import CustomSelect from '../Core/Select/Select';
import CustomSelect from '../Core/CustomSelect'
import Button from '../Core/Button/Button';
import DataTable from '../Core/DataTableCustom/DTM';
import TableIcon from '../Icons/TableIcon';
import useCompanyInfo from '../../hooks/useCompanyInfo';
import { employeesSelector } from '../../store/settings/selectors';
import { eventsSelector, eventsLoadingSelector } from '../../store/events/selectors';
import { getAccountGroups } from '../../store/settings/actions';
import { getEventsList, enterViewed, getEventView } from '../../store/events/actions';
import { loadEmployeesAll } from '../../store/settings/actions';
import { getJobTypes } from '../../store/jobTypes/actions';
import { getPlaces } from '../../store/places/actions';
import usePermissions from '../Core/usePermissions';
import EventCard from './EventCard';
import FavoriteFilters from '../FavotiteFilters'
import { generateResourcesFromEmployees, getCheckedEmployeeIds, setCheckedEmployees, updateAllEmployees } from '../../components/TimeOff/Calendar/utils'
import { getSkills } from '../../store/skills/actions';
import { skillsSelector } from '../../store/skills/selectors';

const columns = [
  { label: 'Event Name', field: 'name', checked: true },
  { label: 'Event Rule', field: 'eventRuleName', checked: true },
  { label: 'Employee name', field: 'employee', checked: true },
  { label: 'Skill', field: 'skill', checked: true },
  { label: 'Place', field: 'place', checked: true },
  { label: 'Group', field: 'group', checked: true },
  { label: 'Sub-Group', field: 'subgroup', checked: true },
  { label: 'Timestamp', field: 'timestamp', checked: true },
];
const columnsWidth = {
  reason: 300,
  employee: 250,
  group: 200,
  place: 200,
};

const permissionsConfig = [
  {
    name: 'create_groups',
    module: 'create_groups',
  },
];

const Events = () => {
  const { getDateFormat } = useCompanyInfo();

  const [itemsArray, setItemsArray] = useState([]);
  const [columnsArray, setColumnsArray] = useState(columns);
  const [selectedItem, setSelectedItem] = useState(null);

  const [dateRange, setDateRange] = useState({
    startDate: startOfWeek(new Date()),
    endDate: endOfWeek(new Date()),
  });

  const { users: employeesStore } = useSelector(employeesSelector);
  const selectSkills = useSelector(skillsSelector);

  const [employees, setEmployees] = useState([]);
  const [skills, setSkills] = useState([]);
  const [search, setSearch] = useState('');

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const eventsLoading = useSelector(eventsLoadingSelector);
  const events = useSelector(eventsSelector);
  const { id: companyId } = useParams();
  const permissions = usePermissions(permissionsConfig);

  useEffect(() => {
    dispatch(getJobTypes(companyId));
    dispatch(getPlaces(companyId));
    dispatch(loadEmployeesAll(companyId));
    dispatch(getAccountGroups(companyId));
    dispatch(getSkills(companyId));
    // sendRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const formatDate2 = getDateFormat({
      'YY.MM.DD': 'YYYY, MMMM, DD',
      'DD.MM.YY': 'DD, MMMM, YYYY',
      'MM.DD.YY': 'MMMM, DD, YYYY',
    });

    const eventsParse = events.reduce((acc, item) => {
      const nextItem = {
        ...item,
        timestamp: moment(item.timestamp).format(`${formatDate2} HH:mm`),
        time_string: moment(item.timestamp).format('DD/MM/YYYY | HH:mm'),
      };
      let time;
      if (!item.seen) {
        time = 'seen';
      } else {
        const partFormat = getDateFormat({
          'YY.MM.DD': 'YYYY. MMMM, DD',
          'DD.MM.YY': 'DD. MMMM, YYYY',
          'MM.DD.YY': 'MMMM. DD, YYYY',
        });
        time = moment(item.timestamp, 'YYYY-MM-DD HH:mm:ss').format(`dddd, ${partFormat}`).toUpperCase();
      }

      if (acc[time]) {
        acc[time].push(nextItem);
      } else {
        acc[time] = [nextItem];
      }
      return acc;
    }, { seen: [] });
    if (!eventsParse.seen.length) {
      delete eventsParse.seen;
    }
    setItemsArray(Object.keys(eventsParse).map((label) => ({
      ...(label !== 'seen' ? {
        label,
      } : {
        label: `${t('PENDING')} (${eventsParse[label].length})`,
        backgroundColor: 'rgba(250, 172, 46, 0.1)',
        titleColor: '#f59f13',
      }),
      //holiday: eventsParse[label][0]?.holiday,
      items: eventsParse[label],
    })));
    // eslint-disable-next-line
  }, [events]);

  useEffect(() => {
    if (Array.isArray(selectSkills)) {
      setSkills(selectSkills.map(s => ({...s, checked: false, title: s.label, isEmployee: true})));
    }
  }, [selectSkills]);

  useEffect(() => {
    if (Array.isArray(employeesStore)) {
      setEmployees(generateResourcesFromEmployees(employeesStore));
    }
  }, [employeesStore])

  useEffect(() => {
    const allColumnsArray = columns.filter((column) => {
      if (!permissions.create_groups && (column.field === 'group' || column.field === 'subgroup')) {
        return false;
      }
      return true;
    });

    setColumnsArray(allColumnsArray);
  }, [permissions, setColumnsArray]);

  const sendRequest = (props = {}) => {
    const { startDate, endDate } = dateRange;
    const employeeIds = getCheckedEmployeeIds(employees)
    const skillIds = skills.filter(s => s.checked).map((item) => item.id)
    dispatch(getEventsList(companyId, {
      date_from: startDate ? format(startDate, 'yyyy-MM-dd HH:mm:ss') : '',
      date_to: endDate ? format(endDate, 'yyyy-MM-dd HH:mm:ss') : '',
      search,
      employees: employeeIds.length ? `[${getCheckedEmployeeIds(employees)}]` : null,
      skills: skillIds.length ? `[${skillIds}]` : null,
      ...props,
    }));
  }

  const sortHandler = useCallback((field, asc) => {
    const sortNumFunction = (a, b) => (asc ? (a[field] - b[field]) : (b[field] - a[field]));
    const sortFunction = (a, b) => {
      if (typeof a[field] === 'number' && typeof b[field] === 'number') {
        return sortNumFunction(a, b);
      }
      if (asc) {
        return a[field].toString().localeCompare(b[field]);
      }
      return b[field].toString().localeCompare(a[field]);
    };
    const sortItems = (array) => {
      const arrayCopy = [...array];
      return arrayCopy.map((group) => {
        const items = [...group.items];
        items.sort(sortFunction);
        return { ...group, items };
      });
    };
    setItemsArray(sortItems);
  }, []);

  const Delimiter = () => (<div className={styles.delimiter} />);

  const applyHandler = () => {
    sendRequest();
  };

  const rowSelectionHandler = (selectedRow) => {
    if (!selectedRow.seen) {
      dispatch(getEventView(companyId, selectedRow.id));
    }

    if (selectedItem && selectedItem.id !== selectedRow.id && !selectedItem?.seen) {
      dispatch(enterViewed(selectedItem));
    }

    const formatDate = getDateFormat({
      'YY.MM.DD': 'YYYY, MMMM, DD',
      'DD.MM.YY': 'DD, MMMM, YYYY',
      'MM.DD.YY': 'MMMM, DD, YYYY',
    });
    
    setSelectedItem({
      ...selectedRow,
      timestamp: moment(selectedRow.timestamp, 'DD, MMMM, YYYY, HH:mm').format(`HH:mm ${formatDate}`),
    });
  };

  const onEmployeesSelectChange = (selectedEmployees) => {
    setEmployees(selectedEmployees)
  };

  const onSkillsSelectChange = (selectedSkills) => {
    setSkills(selectedSkills);
  };

  const searchHandler = (term) => {
    setSearch(term);
  };

  const handleChangeActiveFavoriteFilter = (data) => {
    const updatedEmployees = data.employees ? setCheckedEmployees(employees, data.employees || [], true) : updateAllEmployees(employees, false)
    setSkills(skills.map(s => ({...s, checked: data.skills?.includes(s.id)})))
    setEmployees(updatedEmployees)
    setDateRange({
      startDate: data.start ? moment(data.start, 'DD-MM-YYYY').toDate() : moment().startOf('isoWeek').toDate(),
      endDate: data.end ? moment(data.end, 'DD-MM-YYYY').toDate() : moment().endOf('isoWeek').toDate(),
    })
    setSearch(data.search || '')
    const employeeIds = getCheckedEmployeeIds(updatedEmployees)
    const skillIds = skills.filter(s => data.skills?.includes(s.id)).map((item) => item.id)

    const filters = {
      date_from: data.start ? moment(data.start, 'DD-MM-YYYY').format('YYYY-MM-DD HH:mm:ss') : moment().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'),
      date_to: data.end ? moment(data.end, 'DD-MM-YYYY').format('YYYY-MM-DD HH:mm:ss') : moment().endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'),
      search: data.search || search,
      employees: employeeIds.length ? `[${getCheckedEmployeeIds(employees)}]` : null,
      skills: skillIds.length ? `[${skillIds}]` : null,
    }

    sendRequest(filters)
  }

  return (
    <MaynLayout>
      <div className={styles.container}>
        <div className={styles.leftContent}>
          <header className={styles.appHeader}>
            <DRP initRange={dateRange} onChange={setDateRange} />
            <div className={styles.hideOn660}>
              <Delimiter />
              <Input
                icon={<SearchIcon />}
                placeholder={`${t('Search')}...`}
                width='100%'
                height='36px'
                value={search}
                onChange={(e) => searchHandler(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && applyHandler()}
              />
            </div>
            <div className={styles.hideOn750}>
              <Delimiter />
              <CustomSelect
                placeholder={t('All skills')}
                buttonLabel={t('Filter')}
                items={skills ?? []}
                onChange={onSkillsSelectChange}
                width='auto'
                withSearch={true}
              />
            </div>

            <div className={styles.hideOn815}>
              <Delimiter />
              <CustomSelect
                placeholder={t('All employees')}
                buttonLabel={t('Filter')}
                items={employees ?? []}
                onChange={onEmployeesSelectChange}
                width='auto'
                withSearch={true}
              />
            </div>
            <div className={styles.hideOn815}>
              <Delimiter />
              <FavoriteFilters
                companyId={companyId}
                onChangeActive={handleChangeActiveFavoriteFilter}
                type="events"
                active={skills.length && employees.length}
                currentFilters={{
                  employees: getCheckedEmployeeIds(employees),
                  skills: skills.filter(s => s.checked).map((item) => item.id),
                  start: dateRange.startDate ? moment(dateRange.startDate).format('DD-MM-YYYY') : null,
                  end: dateRange.endDate ? moment(dateRange.endDate).format('DD-MM-YYYY') : null,
                  search,
                }} />
            </div>
            <div className={styles.hideOn936}>
              <Delimiter />
              <Button onClick={applyHandler}>{t('Apply')}</Button>
            </div>
          </header>
          <Delimiter />
          <DataTable
            data={itemsArray || []}
            columns={columnsArray || []}
            columnsWidth={columnsWidth}
            onColumnsChange={setColumnsArray}
            // todo
            // sortable
            loading={eventsLoading}
            onSort={sortHandler}
            selectedItem={selectedItem}
            setSelectedItem={rowSelectionHandler}
            verticalOffset='123px'
            white
          />
        </div>

        <div className={styles.rightSidebar}>
          {
            selectedItem
              ? <EventCard selectedItem={selectedItem} />
              : (
                <div className={styles.empty}>
                  <TableIcon />
                  <div className={styles.empty__text}>
                    {t('Select any entry to get a detailed editable info')}
                  </div>
                </div>
              )
          }
        </div>
      </div>
    </MaynLayout>
  );
};

export default Events;
